import React from "react";
import { Parallax } from "react-parallax";
import { appleAppStoreLink, googlePlayStoreLink } from "../config/commonConfig";

function GetTheApp() {
  return (
    <section id="download" className="hero-wrap">
      <div className="hero-mask opacity-9 bg-primary" />

      <Parallax
        bgImage="images/intro-bg-2.jpg"
        bgImageAlt="Intro"
        strength={200}
      >
        <div className="hero-content section">
          <div className="container">
            <div className="justify-content-center text-center">
              <h2 className="text-9 fw-600 text-white text-center mb-3">
                Acesse o Sistema
              </h2>
              <hr className="heading-separator-line bg-white opacity-10 mx-auto" />
              <p className="lead text-center text-white mb-4">
                Comece agora! Junte-se às agências que já transformaram sua gestão com o Integrare.
              </p>
              <a
                className="btn btn-light btn-lg mx-3 my-2 px-4"
                href="/auth/register"
                title="Criar Conta"
              >
                Criar Conta
              </a>
              <a
                className="btn btn-outline-light btn-lg mx-3 my-2 px-4"
                href="/auth/login"
                title="Fazer Login"
              >
                Fazer Login
              </a>
            </div>
          </div>
        </div>
      </Parallax>
    </section>
  );
}

export default GetTheApp;
